import * as React from "react";
import { Button, Form, Dropdown, Card, ButtonToolbar } from "react-bootstrap";
import I18n from "lib/I18n";
import style from "./style.module.css";
import { envColors } from "../../constants";
import { BsSearch } from "react-icons/bs";
import { observer } from "mobx-react-lite";
import { getStore } from "../../store";
import { Spreadsheet } from "lib/components/Spreadsheet";

export const TableStatus = observer(() => {
  const { env, tableStatus } = getStore();
  const onGetTableStatus = () => {
    tableStatus.getTableStatus();
  };

  const onChangeEnv = (value: string | null) => {
    if (value == null) {
      return;
    }
    env.selected = value;
  };

  const envColor = (value: string) => {
    return envColors[value] || "primary";
  };

  const renderEnvItems = () => {
    return env.list.map((value) => (
      <Dropdown.Item key={value} eventKey={value}>
        {value}
      </Dropdown.Item>
    ));
  };

  const renderFilter = () => {
    return (
      <Form>
        <ButtonToolbar>
          <Dropdown className="me-2" onSelect={onChangeEnv}>
            <Dropdown.Toggle
              id="envdropdown"
              variant={envColor(env.selected)}
              title={env.selected}
              key={env.selected}
            >
              {env.selected}
            </Dropdown.Toggle>
            <Dropdown.Menu>{renderEnvItems()}</Dropdown.Menu>
          </Dropdown>
          <Button className="search-button me-2" onClick={onGetTableStatus}>
            <BsSearch />
          </Button>
        </ButtonToolbar>
        {tableStatus.isLoading ? "Loading..." : ""}
      </Form>
    );
  };

  const renderTable = () => {
    const columns = tableStatus.columns;
    if (columns.length === 0) {
      return null;
    }
    return (
      <div>
        <div>
          <p>
            取得数: {tableStatus.rows.length} 総数: {tableStatus.rowCount}
          </p>
        </div>
        <Spreadsheet
          data={tableStatus.rows}
          columns={columns}
          rowHeaders
          height={600}
          readOnly
        />
      </div>
    );
  };

  return (
    <div className={style.root}>
      <Card>
        <Card.Header>
          {I18n.t("event_master_editor.messages.table_status_desc")}
        </Card.Header>
        <Card.Body>
          {renderFilter()}
          {renderTable()}
        </Card.Body>
      </Card>
    </div>
  );
});
